"use client";

import Image from "next/image";
import React from "react";
import Slider from "react-slick";
import Link from "next/link";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "./SimpleSlider.module.css";

export interface BannersResponse {
  id: number;
  image: string;
  heading?: string;
  subHeading?: string;
  productId: {
    slug: string;
  };
}

interface Props {
  banners: BannersResponse[];
}

export default ({ banners }: Props) => {
  const settings = {
    dots: banners.length > 1,
    arrows: false,
    infinite: banners.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Slider {...settings} className={styles.slickdots}>
      {banners.map((banner) => (
        <div key={banner.id}>
          {banner.productId ? (
            <Link href={`/products/${banner.productId.slug}`}>
              <Image
                className="w-full h-[550px]"
                src={banner.image}
                alt={banner.productId.slug}
                width={750}
                height={550}
              />
            </Link>
          ) : (
            <Image
              className="w-full h-[550px]"
              src={banner.image}
              alt="Banner image"
              width={750}
              height={550}
            />
          )}
        </div>
      ))}
    </Slider>
  );
};
